import React, { useEffect, useState } from 'react';
import firebase from '@config/firebase.config';
import { useSelector, useDispatch } from 'react-redux';
import { authActionTypes } from '@/store/Auth/Auth.actionTypes';
import { useIsAdmin } from '@/hooks/usePermission';
import { Banner } from '../Banner';
import { useReportSubscriptionBanner } from '../../contexts/SubscriptionBanner.context';
const database = firebase.firestore();
export const SubscriptionSeatsWarning = () => {
  const [isVisible, setIsVisible] = useState(false);
  const profile = useSelector((state) => state.auth?.profile);
  const companyId = profile?.activeCompany?.companyId;
  const dispatch = useDispatch();
  const isAdmin = useIsAdmin();

  useEffect(() => {
    if (!isAdmin) return;
    const companyQuery = database.collection('companyDatabase').doc(companyId);

    const unsubscribe = companyQuery.onSnapshot((snapshot) => {
      const companyData = snapshot.data();
      dispatch({
        type: authActionTypes.SET_SUBSCRIPTION_DATA,
        payload: companyData?.subscriptions,
      });
      const isSeatsExhausted =
        companyData?.subscriptions?.occupiedSeats >=
          companyData?.subscriptions?.seats &&
        companyData?.subscriptions?.seatsExhausted;
      if (
        isSeatsExhausted &&
        companyData?.subscriptions?.status === 'active' &&
        companyData?.subscriptions?.subscriptionEndDate?.toDate() > new Date()
      ) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    });
    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [companyId, dispatch, isAdmin]);
  const handleClose = () => {
    setIsVisible(false);
  };
  useReportSubscriptionBanner(isVisible);

  if (!isVisible) return null;

  return (
    <Banner onClose={handleClose}>
      Your plan has reached the maximum number of seats.&nbsp; In case you want
      to add more seats, Please Modify Seats on your current subscription.
    </Banner>
  );
};
